import React, {
  useRef,
  useMemo,
  useState,
  useCallback,
  ReactNode,
} from "react";
import { withRouter } from "react-router-dom";

import {
  ActionToolbar,
  DialogWithActions,
  EditButton,
  GqlTable,
} from "../../components";

import { Button, Container, IconButton, Tooltip } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

import { QUERIES } from "../../../graphql";
import { Amenity, CreateAmenityData } from "../../../graphql/models";
import { AmenityForm } from "./amenity_form";

import useAmenitiesStyle from "./amenities.style";
import { useUserState } from "../../../context";
import { BookOutlined, InfoOutlined } from "@material-ui/icons";

function AmenitiesPage(props: any) {
  const classes = useAmenitiesStyle();

  const tableRef = useRef();

  const { userRole } = useUserState();
  const [formDialogOpened, setFormDialogOpened] = useState(false);
  const [formAmenity, setFormAmenity] = useState<
    Amenity | CreateAmenityData | undefined
  >(void 0);

  const addNewAmenity = () => {
    setFormAmenity({} as Amenity);
    setFormDialogOpened(true);
  };

  const editAmenity = (row) => {
    setFormAmenity({
      ...row,
    });
    setFormDialogOpened(true);
  };

  const onValueUpdatedSuccessfully = () => {
    setFormAmenity(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const gqlTableRowActions = useCallback(
    (row) => {
      const actions: ReactNode[] = [];
      if (userRole === "system_admin") {
        actions.push(<EditButton onClick={() => editAmenity(row)} />);
      }

      return actions;
    },
    [userRole]
  );

  const actionToolbarActions = useMemo(() => {
    const actions: any[] = [];
    if (userRole === "system_admin") {
      actions.push(
        <Button
          key="system_admin-button"
          variant="contained"
          color="primary"
          onClick={() => addNewAmenity()}
        >
          Aggiungi Nuovo
        </Button>
      );
    }
    return actions;
  }, [userRole]);

  function summaryInfo(row: Amenity) {
    const items: JSX.Element[] = [];
    if (row.i18n.summaryInfo_it) {
      items.push(
        <Tooltip title={`Campo "Informazioni utili" personalizzato`}>
          <IconButton>
            <InfoOutlined />
          </IconButton>
        </Tooltip>
      );
    }
    if (
      !row.i18n.categoryName_en ||
      !row.i18n.name_en ||
      !row.i18n.summaryInfo_en
    ) {
      items.push(
        <Tooltip title={`Non tutti i campi sono stati tradotti`}>
          <IconButton>
            <BookOutlined />
          </IconButton>
        </Tooltip>
      );
    }
    if (items.length === 1) return items[0];
    return <>{items}</>;
  }

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <>
        <ActionToolbar title={"Amenities"} actions={actionToolbarActions} />
        <GqlTable
          ref={tableRef}
          columns={["", "Nome", "Categoria", "Palazzo", "Info"].map((v) => (
            <TableCell>{v}</TableCell>
          ))}
          query={QUERIES.AMENITIES}
          queryResultDataField="amenities"
          rows={(row) => (
            <>
              <TableCell>{gqlTableRowActions(row)}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.categoryName}</TableCell>
              <TableCell>{row.building.name}</TableCell>
              <TableCell>{summaryInfo(row)}</TableCell>
            </>
          )}
        />
        <DialogWithActions
          fullScreen
          open={formDialogOpened}
          setOpen={setFormDialogOpened}
          title={"Aggiungi / Modifica Amenity"}
        >
          <AmenityForm
            value={formAmenity}
            onValueUpdatedSuccessfully={onValueUpdatedSuccessfully}
          />
        </DialogWithActions>
      </>
    </Container>
  );
}

export default withRouter(AmenitiesPage);
